<template>
  <div>
    <v-row no-gutters>
      <span class="body-2 font-weight-medium">Your Mapping Licences: PSGA</span>
    </v-row>

    <v-row>
      <v-col>
        <v-row no-gutters class="mt-2">
      <span class="body-2">
        The Public Sector Geospatial Agreement (PSGA) is the agreement that
        <span class="body-2 font-weight-medium">
          licences your Council to use Ordnance Survey data.
        </span>
      </span>
        </v-row>
        <v-row no-gutters class="mt-2">
          <span class="body-2">Having a PSGA licence associated with your account will give you access to the highest detail of Ordnance Survey mapping available.</span>
        </v-row>

        <v-row no-gutters class="ml-4">
          <v-radio-group column v-model="knowsPSMA">
            <v-radio label="I know our PSGA Number"
                     value="yes"
                     color="info">
            </v-radio>
            <v-radio label="I don't know our PSGA Number"
                     value="no"
                     color="info">
            </v-radio>
          </v-radio-group>
        </v-row>

        <div v-if="knowsPSMA !== ''">
          <div v-if="knowsPSMA === 'yes'">
            <v-row no-gutters>
              <span class="body-2 font-weight-medium">Please enter your PSGA Number:</span>
            </v-row>
            <v-row no-gutters>
              <span class="body-2">Your PSGA Number will start with 'AC'</span>
            </v-row>
            <v-row no-gutters class="mt-2">
              <v-col>
                <v-text-field outlined dense
                              v-model="psmaInput"
                              placeholder="PSGA Number"
                              :error-messages="isPsmaValid"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <div v-else>
            <v-row no-gutters>
          <span class="body-2">
            Don't worry, getting your PSGA number from Ordnance Survey is easy and free.
          </span>
            </v-row>
            <v-row no-gutters class="mt-2">
          <span class="body-2">
            Simply complete the
            <span class="body-2 font-weight-medium">
              <a target="_blank"
                 href="https://www.ordnancesurvey.co.uk/business-government/licensing-agreements/register-for-the-psga-and-osma">PSGA Registration Form</a>
            </span>
            and wait to receive your licence number (this may take a few days). In the meantime, complete the form and you can inform us of the number later.
          </span>
            </v-row>
          </div>
        </div>
      </v-col>
      <v-col>
        <img src="@/assets/withwithout_psma.jpg">
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-2">
      <span v-if="isAllValid" class="body-2">Click "Next" to continue the signup process.</span>
      <div v-else>
        <span v-if="knowsPSMA === ''" class="body-2 font-weight-medium" style="color: #BF1722">Please select an option.</span>
        <span v-else-if="!validPsma" class="body-2 font-weight-medium" style="color: #BF1722">Please enter your PSGA Number.</span>
      </div>
    </v-row>
  </div>

</template>

<script>
  export default {
    name: "StepSix",
    components: {},
    props: {
      valid: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        knowsPSMA: '',
        psmaInput: '',
        validPsma: '',
      }
    },
    computed: {
      isPsmaValid() {
        let psma = this.psmaInput;
        let regex = /^AC\d{10}$/; // regex pattern
        let messages = [];
        if (psma === '') {
          this.validPsma = false;
        } else if (!regex.test(psma)) {
          this.validPsma = false;
          messages.push('Invalid PSGA number format.');
        } else {
          this.validPsma = true;
          messages = [];
        }
        return messages;
      },
      isAllValid() {
        let valid = this.knowsPSMA !== '' && (this.knowsPSMA === 'yes' ? this.validPsma : true);
        this.$emit('update:valid', valid);
        if (valid) {
          if (this.knowsPSMA === 'yes') {
            this.$store.commit('SET_PSMA_NUMBER', this.psmaInput);
            this.$store.commit('SET_HAS_PSMA', true);
          }
        } else {
          this.$store.commit('SET_PSMA_NUMBER', '');
          this.$store.commit('SET_HAS_PSMA', false);
        }
        return valid;
      },
    },
    methods: {}
  }
</script>
